import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="policy-container">
      <h1>Terms & Conditions</h1>
      <p>
        Welcome to <strong>Armani Makhana Company</strong>. By purchasing or using our
        products, you agree to the following terms and conditions. These ensure
        a safe, transparent, and reliable shopping experience for all our
        customers.
      </p>

      <h2>1. Orders & Payments</h2>
      <ul>
        <li>
          All orders must be paid in full at the time of purchase through our
          secure payment gateways.
        </li>
        <li>
          We accept major online payment methods including UPI, net banking,
          debit/credit cards, and wallets.
        </li>
        <li>
          Once an order is confirmed, it cannot be canceled or refunded unless
          it falls under our return/refund policy.
        </li>
      </ul>

      <h2>2. Shipping & Delivery</h2>
      <ul>
        <li>
          Orders are usually processed and shipped within <strong>2–5 business
          days</strong>.
        </li>
        <li>
          Delivery timelines may vary depending on the location, courier
          service, or unforeseen delays.
        </li>
        <li>
          Armani Makhana Company is not responsible for delays caused by courier or
          logistics partners.
        </li>
      </ul>

      <h2>3. Returns & Refunds</h2>
      <ul>
        <li>
          Due to hygiene and quality reasons, <strong>returns are only accepted</strong> 
          if the product is defective, damaged, or incorrect, and must be unworn/unwashed.
        </li>
        <li>
          Refund or exchange requests must be raised within <strong>48 hours</strong> of
          receiving the order, along with proper proof (images/videos).
        </li>
        <li>
          Eligible refunds will be processed to the original payment method
          within 7–10 working days.
        </li>
      </ul>

      <h2>4. Product Usage & Care</h2>
      <ul>
        <li>
          We recommend following the care instructions provided with each garment to maintain quality and longevity.
        </li>
        <li>
          Armani Makhana Company will not be held liable for damage due to improper care, alterations, or washing.
        </li>
        <li>
          Store clothing items in a cool, dry place and avoid exposure to harsh chemicals for best results.
        </li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>
        All product designs, images, content, and brand assets of <strong>Armani Makhana Company</strong> 
        are the exclusive property of the brand and may not be copied, reproduced, or used without permission.
      </p>

      <h2>6. Policy Updates</h2>
      <p>
        Armani Makhana Company reserves the right to update or modify these terms at any
        time. Updates will be reflected on this page, and customers are advised
        to review them periodically.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        For queries, feedback, or support, you can reach us at:
      </p>
      <ul>
        <li>
          <strong>Phone:</strong> 7977508283
        </li>
        <li>
          <strong>Email:</strong> armanienterpriises@gmail.com
        </li>
        <li>
          <strong>Address:</strong> Mumbai, MH - 400067, India
        </li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
